import React from "react";
import { Link } from "react-router-dom";

function AdminNavbar() {
  return <></>;
}

// Add this to your nav items
<li className="nav-item">
  <Link to="/admin/attendance">Attendance</Link>
</li>

export default AdminNavbar;
